import * as signalR from "@microsoft/signalr";
import common from "../../helper/common";

/**
 * SignalR Room Management
 * Handles joining rooms for user and club notifications
 */
class SignalRRooms {
  /**
   * Join user to rooms (user.id and user.defaultClubId)
   * Backend: public async Task JoinRoom(string id)
   */
  static async joinRooms(connection) {
    if (!connection || connection.state !== signalR.HubConnectionState.Connected) {
      return;
    }

    try {
      // Get user data
      const user = global.user || common.getUser();
      if (!user) {
        return;
      }

      // Join room by user ID
      if (user.id) {
        await connection.invoke("JoinRoom", user.id.toString());
      }
      console.log("Joined room by user ID", user.id);
      // Join room by default club ID
      if (user.defaultClubId) {
        await connection.invoke("JoinRoom", user.defaultClubId.toString());
      }
      console.log("Joined room by default club ID", user.defaultClubId);
    } catch (error) {
      console.error("[SignalR] Failed to join rooms:", error);
    }
  }
}

export default SignalRRooms;

